import * as React from "react";
import { useBreakpoint } from "../../../hooks/useBreakpoint";
import { getValueOnBreakpoint } from "../../../lib/getValueOnBreakpoint";
import { isEqual } from "lodash";
import {
  IXHeaderProps,
  XHeaderProps,
} from "../../../utils/interfaces/common/XHeader.interfaces";

import XHeaderCore from "./core";

const compareProps = (prevProps: any, nextProps: any) => {
  return isEqual(prevProps, nextProps);
};

const XHeader: React.FC<XHeaderProps> = React.memo(
  ({ initData = { all: {} } }) => {
    // WE TRACK THE BREAK POINTS CHANGES
    const breakpoint = useBreakpoint();

    // WE NOW USE THE CURRENT BREAKPOINT VALUE ON THIS ELEMENT
    const valueAtBreakPoint = getValueOnBreakpoint<IXHeaderProps>(
      initData,
      breakpoint
    );

    return <XHeaderCore index="HEADER" props={valueAtBreakPoint} />;
  },
  compareProps
);

export default XHeader;
